module.exports = __webpack_public_path__ + "icon-kafka.2Q8U1r43.svg";